import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import './purchasingDraft.css';
import DemandPlanning from './DemandPlanning';
import Sourcing from './Sourcing';
import Suppliers from './Suppliers';

const SECTIONS = [
    { title: 'Resumen', icon: 'pi pi-chart-bar', description: 'Vista general de las compras y sus principales indicadores.' },
    { title: 'Órdenes de Compra', icon: 'pi pi-shopping-cart', description: 'Organización y seguimiento de las órdenes de compra.' },
    { title: 'Proveedores', icon: 'pi pi-users', description: 'Directorio y datos de los proveedores.' },
    { title: 'Inventario y Reabastecimiento', icon: 'pi pi-box', description: 'Consulta de existencias y planificación del reabastecimiento.' }
];

export default function PurchasingDraft() {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="card purchasing-draft">
            <header className="purchasing-draft__header">
                <h1>Compras Draft</h1>
                <p>Resumen, órdenes de compra, proveedores e inventario en un solo lugar.</p>
            </header>
            <TabView activeIndex={activeTab} onTabChange={(event) => setActiveTab(event.index)} renderActiveOnly>
                {SECTIONS.map((section) => (
                    <TabPanel key={section.title} header={section.title}>
                        {section.title === 'Órdenes de Compra' ? <Sourcing /> : section.title === 'Inventario y Reabastecimiento' ? <DemandPlanning /> : section.title === 'Proveedores' ? <Suppliers /> : <section className="purchasing-draft__section" aria-label={section.title}>
                            <span className={`${section.icon} purchasing-draft__icon`} aria-hidden="true" />
                            <h2>{section.title}</h2>
                            <p>{section.description}</p>
                            <p className="purchasing-draft__status">Esta sección está en preparación.</p>
                        </section>}
                    </TabPanel>
                ))}
            </TabView>
        </div>
    );
}
